module.exports = __webpack_public_path__ + "static/media/The Girl in a Swing_main.44c91fb1.jpg";